module.exports = __webpack_public_path__ + "static/a-local-beer-8eccae344f25d8a1aa2d95da1c35354f.jpg";